import {
    GET_PLATFORM_SUMMARY,
    PLATFORM_LOADING,
    RENT_CASINO,
    GET_DAILY_INCOME_LIST,
    GET_TOKEN_HOLDER_HISTORY,
    PROFIT_DIVIDEND, GET_PROFIT_DIVIDEND_LIST, GET_GAME_SHARE_RECORD,
    GET_GAME_EXCHANGE_DAILY,
    GET_GAME_PERSONAL_SHARE,
    GET_GAME_PROFIT_RECORD,
    PLATFORM_STOP_LOADING, TOKEN_STATUS
} from '../actions/types';

const initialState = {
    platformSummary: null,
    rentcasinoresult:null,
    dailyIncomeList:null,
    gameExchangeDailyList:null,
    gameProfitRecordsList:null,
    tokenHolderHistoryList:null,
    profitDividendRecordList:null,
    gameSharesRecordList:null,
    loading: false,
    tokenStatus:null
};

export default function(state = initialState, action) {
  switch (action.type) {

      case TOKEN_STATUS:
          return {
              ...state,
              tokenStatus: action.payload,
          };

      case PLATFORM_STOP_LOADING:
          return {
              ...state,
              loading: false
          };

      case PLATFORM_LOADING:
          return {
              ...state,
              loading: true
          };

      case GET_PLATFORM_SUMMARY:
          return {
              ...state,
              platformSummary: action.payload,
              loading: false
          };

      case GET_GAME_SHARE_RECORD:
          return {
              ...state,
              gameSharesRecordList: action.payload,
              loading: false
          };

      case GET_GAME_PROFIT_RECORD:
          return {
              ...state,
              gameProfitRecordsList: action.payload,
              loading: false
          };

      case GET_GAME_PERSONAL_SHARE:
          return {
              ...state,
              gamePersonalShareslist: action.payload,
              loading: false
          };

      case PROFIT_DIVIDEND:
          return {
              ...state,
              loading: false
          };

      case GET_DAILY_INCOME_LIST:
          return {
              ...state,
              dailyIncomeList: action.payload,
              loading: false
          };

      case GET_GAME_EXCHANGE_DAILY:
          return {
              ...state,
              gameExchangeDailyList: action.payload,
              loading: false
          };

      case GET_PROFIT_DIVIDEND_LIST:
          return {
              ...state,
              profitDividendRecordList: action.payload,
              loading: false
          };

      case GET_TOKEN_HOLDER_HISTORY:
          return {
              ...state,
              tokenHolderHistoryList: action.payload,
              loading: false
          };

      case RENT_CASINO:
          return {
              ...state,
              rentcasinoresult: action.payload,
              loading: false
          };
 
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/platformReducer.js